
import { Textarea } from "@/components/ui/textarea";
import { useLanguage } from "@/contexts/LanguageContext";

interface MessageFieldProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const MessageField = ({ value, onChange }: MessageFieldProps) => {
  const { t } = useLanguage();
  
  return (
    <div className="mb-6">
      <label htmlFor="message" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        {t('contact_message')}
      </label>
      <Textarea
        id="message"
        name="message"
        value={value}
        onChange={onChange}
        maxLength={2000}
        placeholder={t('contact_message_placeholder')}
        className="w-full px-4 py-2 min-h-[120px] border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-md focus:outline-none focus:ring-2 focus:ring-primary/50"
      />
    </div>
  );
};

export default MessageField;
